/** Same-origin API base as other MNF frontends (ScriptPad, IdeaMall, etc.). */
const origin =
  (typeof window !== "undefined" && window.MNF_API_ORIGIN) ||
  (typeof window !== "undefined" ? window.location.origin : "") ||
  process.env.REACT_APP_API_URL ||
  "http://127.0.0.1:8000";

const URL = origin;

export { URL, origin as API_ORIGIN };
